import React, { useEffect, useRef, useState } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, CircularProgress, DialogContentText } from '@material-ui/core';

import API from 'utils/api';
import { useSources } from 'hooks';
import { call } from 'utils';
import { classes } from 'components/utils';
import { ConfirmDialog, SectionTitle } from 'components';
import { compileResults, hasAllResults, readQuestions } from './helpers';
import StopDialogContent from './StopDialogContent';

import styles from './StopInteractionDialog.module.scss';

const StopInteractionDialog = ({ interaction, onClose }) => {
  const [state, setState] = useState();
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);

  const sources = useSources();
  const showOptions = useRef();

  if (interaction) {
    showOptions.current =
      interaction.type === 'prediction' || interaction.type === 'picks';
  }

  useEffect(() => {
    if (interaction) {
      setState(
        showOptions.current
          ? {
              title: 'Select the right answer for each question to stop the Interaction',
              questions: readQuestions(interaction, true),
            }
          : { title: 'Confirmation' }
      );
    } else {
      const timer = setTimeout(() => setState(null), 500);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [interaction]);

  if (!state) {
    return null;
  }

  const onSubmit = async ok => {
    if (ok) {
      setConfirm(false);
      setBusy(true);

      try {
        const res = compileResults(state.questions, showOptions.current);
        await API.stopInteraction(interaction._id, { questions: res }, sources);
      } catch (err) {
        console.log(err);
      } finally {
        setBusy(false);
        call(onClose);
      }
    } else {
      setConfirm(x => !x);
    }
  };

  const renderTitle = () => {
    return showOptions.current ? (
      <div style={{ display: 'flex' }}>
        <SectionTitle title={state.title} iconPosition="top">
          Before stopping the interaction, it is possible to define the results of the
          questions that are still open and send notifications to the users who got the
          predictions right.
        </SectionTitle>
      </div>
    ) : (
      state.title
    );
  };

  return (
    <Dialog open={!!interaction}>
      <DialogTitle>{renderTitle()}</DialogTitle>

      <DialogContent className={classes(styles.content, busy ? styles.busy : '')}>
        {state.questions ? (
          <StopDialogContent
            questions={state.questions}
            showOptions={showOptions.current}
            onChange={() => setState(state => ({ ...state }))}
            required
          />
        ) : (
          <DialogContentText>
            This will stop the interaction, do you want to proceed?
          </DialogContentText>
        )}

        <div className={styles.overlay}>
          <CircularProgress />
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>

        <Button
          onClick={() => onSubmit(hasAllResults(state))}
          variant="contained"
          color="primary"
          disabled={busy}
        >
          Stop Interaction
        </Button>
      </DialogActions>

      <ConfirmDialog
        open={confirm}
        onClose={onSubmit}
        title="Attention"
        message={[
          'One or more questions remain unanswered.',
          'Do you want to stop this Interaction anyway?',
        ]}
      />
    </Dialog>
  );
};

export default StopInteractionDialog;
